import { I18n } from '@boschebike/ebds-js';
import { HeaderProps, InternalNavigationLink, PageTabless } from '../../components';
import { Container } from '../../components/layout/Container';
import { useContent } from '../../hooks/use-content';
import envReader from '../../config/envReader';

const docMap = [
  // Asia Pacific
  { name: 'State of Israel (English)', link: 'DPN_Rest_of_World_English.pdf' },
  { name: 'Republic of India (English)', link: 'DPN_Rest_of_World_English.pdf' },
  { name: 'United Arab Emirates (English)', link: 'DPN_Rest_of_World_English.pdf' },
  { name: 'Republic of Indonesia (English)', link: 'DPN_Rest_of_World_English.pdf' },
  // Europe
  { name: 'Republic of Serbia (English)', link: 'DPN_Rest_of_World_English.pdf' },
  { name: 'Bosnia and Herzegovina (English)', link: 'DPN_Rest_of_World_English.pdf' },
  { name: 'British Overseas Regions (English)', link: 'DPN_Rest_of_World_English.pdf' },
  { name: 'Régions Françaises D\'outre-mer (Français)', link: 'DPN_French_regions_final.pdf' },
  { name: 'Nederlandse Overzeese Gebieden (Nederlands)', link: 'DPN_Dutch_regions_final.pdf' },
  // South America
  { name: 'República Federativa do Brasil (Português)', link: 'DPN_Brazil_Portuguese_final.pdf' },
  { name: 'República de Chile (Español)', link: 'DPN_Chile_Spanish_final.pdf' },
  { name: 'Estados Unidos Mexicanos (Español)', link: 'DPN_Mexico_Spanish_final.pdf' },
  { name: 'República Argentina (Español)', link: 'DPN_Argentina_Spanish_final.pdf' },
  { name: 'República de Colombia (Español)', link: 'DPN_Colombia_Spanish_final.pdf' },
  { name: 'República de Costa Rica (Español)', link: 'DPN_Costa_Rica_Spanish_final.pdf' },
  { name: 'República Bolivariana de Venezuela (Español)', link: 'DPN_Venezuela_Spanish_final.pdf' },
  { name: 'República del Ecuador (Español)', link: 'DPN_Ecuador_Spanish_final.pdf' },
].sort((a, b) => a.name.localeCompare(b.name));

export const DataProtectionPolicyPsPage = () => {
  const content: I18n = useContent();

  const contentKeyHeadline: string = content.t('portal.dataProtection.headline');
  const contentKeySubHeadline: string = content.t('portal.dataProtection.subheadline');

  const header: HeaderProps = {
    title: contentKeyHeadline,
    headline: contentKeySubHeadline,
    lightWeight: true,
  };

  return (
    <PageTabless headerProps={header}>
      <Container multiColumn>
        <ul className="dpa-list">
          {docMap.map((d) => (
            <li key={d.name}>
              <InternalNavigationLink
                href={`${envReader.VITE_PUBLIC_URL}/data-protection-policy-ps/${d.link}`}
                text={d.name}
              />
            </li>
          ))}
        </ul>
      </Container>
    </PageTabless>
  );
};
